export const Note = 'Note';
export const UploadFile = 'UploadFile';
export const DownloadFiles = 'DownloadFiles';
export const Presenter = 'Presenter';
export const Vote = 'Vote';
export const LikeDislike = 'LikeDislike';
export const Rating = 'Rating';
export const TrueFalse = 'TrueFalse';
export const YesNo = 'YesNo';
export const VisualVote = 'VisualVote';

export { NoteActivity } from './note/note-activity';
export { UploadFileActivity } from './upload-file/upload-file-activity';
export { DownloadFilesActivity } from './download-files/download-files-activity';
export { PresenterActivity } from './presenter/presenter-activity';
export { VoteActivity } from './vote/vote-activity';
export { LikeDislikeActivity } from './like-dislike/like-dislike-activity';
export { RatingActivity } from './rating/rating-activity';
export { TrueFalseActivity, YesNoActivity } from './true-false/true-false-activity';
export { VisualVoteActivity } from './visual-vote/visual-vote-activity';